import ButtonState.NO
import ButtonState.YES
import IncludeExcludeState.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.remember
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.DisplayStyle.Companion.Flex
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

enum class IncludeExcludeState {
    INCLUDE,
    EXCLUDE,
    NONE
}

class IncludeExcludeFilter<Datatype>(
    val title: String,
    val allValues: List<String>,
    val filterFunction: ((String, String) -> Boolean)?,
    val match: (Datatype, Collection<String>, Collection<String>) -> Boolean
) : FilterSpec<Datatype> {
    @Composable
    override fun render(data: List<Datatype>, onFilterChange: ((Datatype) -> Boolean) -> Unit) {
        val state = remember { mutableStateMapOf<String, IncludeExcludeState>() }
        val hasFilter = state.any { it.value != NONE }
        val callOnChange = {
            val required = state.filterValues { it == INCLUDE }.keys
            val excluded = state.filterValues { it == EXCLUDE }.keys
            onFilterChange { dataItem ->
                match(dataItem, required, excluded)
            }
        }
        FilterBox(title, hasFilter, allValues, filterFunction, {
            Button({
                style { myButtonStyle() }; onClick {
                for (value in allValues) state[value] = NONE; callOnChange()
            }
            }) { Text("reset") }
        }) { value ->
            IncludeExcludeLine(value, state[value] ?: NONE) {
                state[value] = it
                callOnChange()
            }
        }
    }

}

@Composable
fun IncludeExcludeLine(name: String, state: IncludeExcludeState, onChange: (IncludeExcludeState) -> Unit) {
    Div({ style {
        display(Flex)
        width(100.percent)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems("center")
    }}) {
        Text(name)
        Span({ style { alignContent(AlignContent.End); marginLeft(30.px); display(Flex) } }) {
            IncludeExcludeButton(INCLUDE, state, onChange)
            IncludeExcludeButton(EXCLUDE, state, onChange)
        }
    }
}

@Composable
fun IncludeExcludeButton(target: IncludeExcludeState, currentState: IncludeExcludeState, onChange: (IncludeExcludeState) -> Unit) {
    Button({
        onClick { if (currentState == target) onChange(NONE) else onChange(target)}
        style {
            if (currentState == target) {
                if (target == INCLUDE) {
                    myButtonStyle(YES)
                } else {
                    myButtonStyle(NO)
                }
            } else {
                myButtonStyle(ButtonState.NONE)
            }
        }
    }) {
        val text = if (target == INCLUDE) "require" else "exclude"
        Text(text)
    }
}